<template>
  <div class="mobile-modal-header" :class="ui?.root" @click.stop="closeAll">
    <UContainer class="flex items-center justify-between pt-4 pb-4">
      <div>
        <h2
          v-if="false"
          class="text-2xl leading-6.5 font-bold text-accent-default"
          :class="ui?.logo"
        >
          {{ ORGANIZATION_DATA.title }}
        </h2>
        <NuxtLink to="/">
          <img
            class="logo-image"
            src="@/assets/logo/logo-primary.svg"
            alt="Лого"
          />
        </NuxtLink>
        <span
          v-if="false"
          class="text-size-sm font-medium text-neutral-default"
          :class="ui?.slogan"
        >
          {{ ORGANIZATION_DATA.slogan }}
        </span>
      </div>

      <div class="flex gap-3">
        <ClientOnly>
          <UButton
            class="max-md:hidden"
            icon="i-local-navigation"
            @click.capture="changeCity"
          >
            {{ selectedCity?.label }}
          </UButton>
        </ClientOnly>

        <UButton
          v-if="!openedSearchModals"
          variant="outline"
          color="neutral"
          icon="i-local-search"
          @click.stop.capture="openSearch"
        />

        <UButton
          v-if="closeBtn"
          variant="outline"
          color="neutral"
          icon="i-local-close"
          @click.stop.capture="emit('toggled', false)"
        />
      </div>
    </UContainer>
  </div>
</template>

<script lang="ts" setup>
import { ORGANIZATION_DATA } from '~/shared'
import SearchModal from './modals/SearchModal.vue'
import CitySelectModal from './modals/CitySelectModal.vue'

defineOptions({
  name: 'SPMobileModalHeader',
})

const emit = defineEmits<{
  toggled: [boolean]
  'city-change': []
}>()

withDefaults(
  defineProps<{
    closeBtn?: boolean
    ui?: {
      root?: string
      logo?: string
      slogan?: string
    }
  }>(),
  {
    closeBtn: true,
    ui: () => ({}),
  },
)

const directoryStore = useDirectoryStore()
const { selectedCity } = storeToRefs(directoryStore)

const overlay = useOverlay()
const searchModal = overlay.create(SearchModal)
const citySelectModal = overlay.create(CitySelectModal)

const openedSearchModals = computed(
  () =>
    overlay.overlays.filter(
      (o) => o.component?.name === 'SearchModal' && o.isOpen,
    )?.length,
)

const openSearch = () => {
  if (!openedSearchModals.value) {
    searchModal.open()
  }
}

const changeCity = () => {
  citySelectModal.open()
}

const closeSearchModal = (event: any) => {
  if (event?.target?.tagName === 'DIV') {
    overlay.closeAll()
  }
}

const closeAll = (event: any) => {
  closeSearchModal(event)
  emit('toggled', false)
}
</script>

<style lang="scss" scoped>
.mobile-modal-header {
  border-bottom: 1px solid var(--color-neutral-muted);

  .logo-image {
    height: 24px;
    margin-bottom: 2px;
  }
}
</style>
